import { CloseOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Select, Checkbox, Row, Col } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { AddFilter, FilterItem } from "../../controls";
import { salesStatuses, productVids } from "../../extensions/helper";

const filterLabels = {
  Statuses: "Статус",
  UserIds: "Исполн.",
  AuthorIds: "Пользов.",
  ManagerIds: "Менеджер",
  ProductVids: "Вид прод.",
};

const SalesFilter = ({ current, filterOptions, userOptions = [], onClose }) => {
  const [item, setItem] = useState({...current});
  const [form] = Form.useForm();

  const statusOptions = salesStatuses.filter((s) => s.value !== 4);
  const productVidOptions = productVids;

  useEffect(() => {
    form.setFieldsValue(current);
  }, [current]);

  const onValuesChange = (value) => {
    setItem((prev) => ({ ...prev, ...value }));
  };

  const filters = Object.entries(item)
    .filter(([key, data]) => {
      const def = filterOptions?.find((f) => f.type === key);
      return !!def && data && typeof data === "object" && "inputType" in data;
    })
    .map(([type, data]) => ({ type, ...data }));

  const handleAddFilter = (type) => {
    if (!type || item[type]) return;

    let options;

    switch (type) {
      case "Statuses":
        options = statusOptions;
        break;
      case "ProductVids":
        options = productVidOptions;
        break;
      case "UserIds":
      case "AuthorIds":
      case "ManagerIds":
        options = userOptions;
        break;
      default:
        options = [];
    }

    setItem((prev) => ({
      ...prev,
      [type]: { value: [], inputType: "multiselect", options },
    }));
  };

  const handleFilterValueChange = (type, data, value) => {
    setItem((prev) => ({
      ...prev,
      [type]: { ...data, value },
    }));
  };

  const handleRemoveFilter = (type) => {
    setItem((prev) => {
      const { [type]: _, ...rest } = prev;
      return rest;
    });
  };

  const onSave = () => {
    const normalized = { ...item };

    Object.entries(normalized).forEach(([key, val]) => {
      if (val && val.inputType === "date" && Array.isArray(val.value)) {
        const [start, end] = val.value;
        normalized[key] = {
          ...val,
          value: [
            start ? dayjs(start) : null,
            end ? dayjs(end) : null,
          ],
        };
      }
    });

    onClose(normalized);
  };

  return <div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
        <div className="sport-modal-title">
          <span>Фильтр продаж</span>
          <CloseOutlined className="sport-section-title-close" onClick={() => onClose()} style={{ zIndex: 9 }}   />
        </div>
        <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 4 }} wrapperCol={{ }} colon={false} layout="inline">
          <Form.Item name="paid" label="Оплачено" className="record-form-item-with-margin-bottom-mobile">
            <Select
              options={[
                { label: "Все", value: null },
                { label: "Да", value: true },
                { label: "Нет", value: false },
              ]}
              className="client-filter-select"
            />
          </Form.Item>
          <Form.Item label=" " className="client-filter-form-item">
            <Row align="middle" className="records-row-mobile">
              <Col>
                <Form.Item name="newClient" valuePropName="checked">
                  <Checkbox style={{fontSize: "12px"}}>Новые</Checkbox>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item name="deleted" valuePropName="checked">
                  <Checkbox style={{fontSize: "12px"}}>Удаленные</Checkbox>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item name="blocked" valuePropName="checked">
                  <Checkbox style={{fontSize: "12px"}}>Заблокир.</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </Form.Item>
          {filters.map((f) => (
            <Form.Item key={f.type} label={filterLabels[f.type] || f.type} className="record-form-item-with-margin-bottom-mobile" style={{ width: "100%" }}>
              <FilterItem type={f.inputType}  value={f.value} options={f.options}
                onChange={(val) => handleFilterValueChange(f.type, f, val)}
                onRemove={() => handleRemoveFilter(f.type)}
                allowSearch
                width="100%"
              />
            </Form.Item>
          ))}

          <Form.Item style={{ width: "100%" }}>
            <AddFilter
              key={filters.length} 
              availableFilters={filterOptions}
              usedFilters={filters.map((f) => f.type)}
              onAdd={handleAddFilter}
            />
          </Form.Item>
          <Button className="sport-btn" onClick={onSave} style={{width: "100%"}}>ОК</Button>
        </Form>
      </div>
    </div>
  </div>
}

export default SalesFilter;